var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditCard = function SvgCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "credit_card_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "credit_card_svg__credit_card"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 20q-.824 0-1.413-.587A1.93 1.93 0 0 1 2 18V6q0-.824.587-1.412A1.93 1.93 0 0 1 4 4h16q.824 0 1.413.588Q22 5.175 22 6v12q0 .824-.587 1.413A1.93 1.93 0 0 1 20 20zm0-8h16V8H4z",
    className: "credit_card_svg__vector"
  }))));
};
export { SvgCreditCard as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgY2xhc3M9InN2Zy1pY29uIj48ZyBjbGFzcz0iY3JlZGl0X2NhcmQiPjxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZD0iTTQgMjBjLS41NSAwLTEuMDItLjE5Ni0xLjQxMy0uNTg3QTEuOTI2IDEuOTI2IDAgMCAxIDIgMThWNmMwLS41NS4xOTYtMS4wMi41ODctMS40MTJBMS45MjYgMS45MjYgMCAwIDEgNCA0aDE2Yy41NSAwIDEuMDIuMTk2IDEuNDEzLjU4OC4zOTEuMzkxLjU4Ny44NjIuNTg3IDEuNDEydjEyYzAgLjU1LS4xOTYgMS4wMi0uNTg3IDEuNDEzQTEuOTI2IDEuOTI2IDAgMCAxIDIwIDIwSDRabTAtOGgxNlY4SDR2NFoiIGNsYXNzPSJ2ZWN0b3IiLz48L2c+PC9zdmc+";